export function uid(): string {
    return Math.random().toString().slice(2);
}
